import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'I tuoi consensi',
  empty: 'Nessuna richiesta di consenso ti riguarda.',
  collectiveNote:
    'È in vigore un accordo collettivo sul reparto; la tua risposta personale non ha effetto finché resta valido.',
  table: {
    department: 'Reparto',
    status: 'Stato',
    basis: 'Base in vigore',
  },
  status: {
    pending: 'In attesa della tua risposta',
    granted: 'Concesso',
    denied: 'Negato',
  },
  basis: {
    personal: 'Personale',
    collective: 'Collettiva',
  },
  actions: {
    grant: 'Concedi',
    deny: 'Nega',
    withdraw: 'Revoca',
  },
};
